export default __webpack_public_path__ + "static/media/Darkblade's Tunic of the Kingmaker.36948ce3.jpg";